/* Generated by ./script/iconify.js */
/* eslint-disable */
import React from 'react'
import PropTypes from 'prop-types'
import IconBase from './IconBase'
import classnames from 'classnames'

const IconSrc_assets_img_s_icPageBlue = ({ className, fill, ...rest }) => {
  const classes = classnames(
    'icon',
    'icon--src_assets_img_s_icpageblue',
    className,
  )

  return (
    <IconBase className={classes} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 19"{...rest}><path className="path1" fill={fill || '#BDBDBD'} fillRule="evenodd" d="M12.108 3.8V1.81l2.045 1.99h-2.045zm-.398 3.8H4.36a.32.32 0 0 1-.324-.317.32.32 0 0 1 .325-.316h7.35a.32.32 0 0 1 .324.316.32.32 0 0 1-.325.317zm0 2.111H4.36a.32.32 0 0 1-.324-.317.32.32 0 0 1 .325-.316h7.35a.32.32 0 0 1 .324.316.32.32 0 0 1-.325.317zm-2.505 2.111H4.361a.32.32 0 0 1-.325-.316.32.32 0 0 1 .325-.317h4.844a.32.32 0 0 1 .325.317.32.32 0 0 1-.325.316zm6.178-8.367L12.469.606C12.118.263 11.478 0 10.981 0H1.26C.606 0 0 .529 0 1.169v16.68C0 18.487.606 19 1.261 19h13.55c.655 0 1.189-.512 1.189-1.152V4.908c0-.485-.266-1.11-.617-1.453z"/></IconBase>
  )
}

IconSrc_assets_img_s_icPageBlue.propTypes = {
  className: PropTypes.string,
}

export default IconSrc_assets_img_s_icPageBlue
/* eslint-enable */



// WEBPACK FOOTER //
// ./src/icons/IconPage.js